import Axios from "axios";
import { baseUrl, tokenHeader } from "../../router";

const state = () => ({
    logs: undefined,
});

const getters = {
    allLogs: (state) => state.logs,
};

const actions = {
    async getLogList({ commit }, data) {
        try {
            let tkHeader = {};
            if (tokenHeader == undefined) {
                tkHeader = {
                    headers: {
                        "Authorization": `Bearer ${JSON.parse(localStorage.getItem("token")).token}`
                    }
                };
            }
            const response = await Axios.post(`${baseUrl}log/logList`, data, tokenHeader != undefined ? tokenHeader : tkHeader);
            if (response.status == 200) {
                commit("setLogs", response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    
}

const mutations = {
    setLogs: (state, data) => {
        return state.logs = data;
    },
};

export default { state, getters, actions, mutations };
